import { Input, Component, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { IEmbeddedContentLink } from 'rev-portal/scheduledEvents/common/EmbeddedContentTypes';

@Component({
	selector: 'vb-webcast-embedded-content',
	templateUrl: './VbWebcastEmbeddedContent.Component.html',
	standalone: false
})
export class VbWebcastEmbeddedContentComponent implements OnChanges {
	@Input() public contentLink: IEmbeddedContentLink;

	public safeUrl: SafeResourceUrl;

	constructor(
		private readonly sanitizer: DomSanitizer,
	) { }

	public ngOnChanges(): void {
		this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.contentLink.resourceUri);
	}

}
